import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import ResourceProperty from '../../../../common/resource/ResourceProperty';

const formatPEN = (value) => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  const amount = Number(value);

  if (Number.isNaN(amount)) {
    return value;
  }

  return `${amount.toFixed(2)} PEN`;
};

const getValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  return value;
};

const TollBasicInformationResource = ({
  location,
  pricePerAxle,
  taxPrePaymentPerAxle,
  provia,
  electronic,
  isExtraordinary,
  electronicPricePerAxle,
  electronicTaxPrePaymentPerAxle,
  business,
}) => {
  const { name, description } = location || {};

  return (
    <Fragment>
      <ResourceProperty label="Nombre:">{getValue(name)}</ResourceProperty>

      <ResourceProperty label="Descripción:">
        {getValue(description)}
      </ResourceProperty>

      <ResourceProperty label="Precio por eje:">
        {formatPEN(pricePerAxle)}
      </ResourceProperty>

      <ResourceProperty label="Impuesto prepago por eje:">
        {formatPEN(taxPrePaymentPerAxle)}
      </ResourceProperty>

      <ResourceProperty label="RUC:">
        {business ? business.businessTaxId : '-'}
      </ResourceProperty>

      <ResourceProperty label="Razon Social:">
        {business ? business.name : '-'}
      </ResourceProperty>

      <ResourceProperty label="Provia:">
        {provia ? 'Sí' : 'No'}
      </ResourceProperty>

      <ResourceProperty label="Electrónico:">
        {electronic ? 'Sí' : 'No'}
      </ResourceProperty>

      <ResourceProperty label="Extraordinario:">
        {isExtraordinary ? 'Sí' : 'No'}
      </ResourceProperty>

      {electronic && (
        <Fragment>
          <ResourceProperty label="Precio electrónico por eje:">
            {formatPEN(electronicPricePerAxle)}
          </ResourceProperty>

          <ResourceProperty label="Impuesto prepago electrónico por eje:">
            {formatPEN(electronicTaxPrePaymentPerAxle)}
          </ResourceProperty>
        </Fragment>
      )}
    </Fragment>
  );
};

TollBasicInformationResource.propTypes = {
  location: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    locationCorrelationId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  }),
  pricePerAxle: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  taxPrePaymentPerAxle: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  electronic: PropTypes.bool,
  isExtraordinary: PropTypes.bool,
  electronicPricePerAxle: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  electronicTaxPrePaymentPerAxle: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  provia: PropTypes.bool,
  business: PropTypes.shape({
    name: PropTypes.string,
    businessTaxId: PropTypes.string,
  })
};

TollBasicInformationResource.defaultProps = {
  location: {
    name: '',
    description: '',
    locationCorrelationId: null,
  },
  pricePerAxle: null,
  taxPrePaymentPerAxle: null,
  electronic: false,
  isExtraordinary: false,
  electronicPricePerAxle: null,
  electronicTaxPrePaymentPerAxle: null,
  provia: false,
  business: null
};

export default TollBasicInformationResource;
